import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Switch from '@material-ui/core/Switch';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import QueryBuilderIcon from "@material-ui/icons/QueryBuilder";
import AnnouncementIcon from '@material-ui/icons/Announcement';
import { Link } from "react-router-dom";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import PropTypes from "prop-types";
import NumberFormat from "react-number-format";
import RangeSlider from "../utils/RangeSlider";
import SearchIcon from "@material-ui/icons/Search";
import { CircularProgress, InputBase } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { db } from "../../config/Firebase";
import {
  createCheckoutSession,
  getStripeRole,
  goToBillingPortal,
} from "../../config/Firebase";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    maxWidth: 500,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  chip: {
    margin: 10,
  },
  head: {
    backgroundColor: "#847df9",
    color: "#FFF",
  },
  headFont: {
    color: "#FFF",
    padding: "5px 15px",
  },
  bullFontColor: {
    color: "red",
  },
  bearFontColor: {
    color: "green",
  },
  buttonList: {  
    display: "flex",
    maxWidth: "400px",
    flexFlow: "row wrap",
    justifyContent: "flex-end",
  },
  buttonListA: {
    marginBottom: "10px",
  }
});

const useRowStyles = makeStyles({
  root: {},
});

function Row(props) {
  const { row } = props;
  // debugger;
  const [open, setOpen] = React.useState(props.initialOpen);
  const classes = useRowStyles();

  useEffect(() => {
    // document.title = `Hello, ${props.name}`;
    setOpen(props.initialOpen);
  }, [props.initialOpen]);

  return (
    <React.Fragment>
      <StyledTableRow className={` ${classes.root}`}>
        <TableCell component="th" scope="row">
          <div
            className="badge btn-outline-success border border-success rounded-pill py-2"
            style={{ width: 55 }}
          >
            {row.ticker}
          </div>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell align="center">
          <NumberFormat
            value={row.todays_vol}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$ "}
          />
        </TableCell>
        <TableCell align="center">
          <NumberFormat
            value={row.avg_vol}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$ "}
          />
        </TableCell>
        <TableCell align="center">
          {row.relative_vol > 1 ? row.relative_vol : row.relative_vol}
        </TableCell>
        <TableCell align="center">{row.past_call}</TableCell>
        <TableCell align="center">{row.past_put}</TableCell>
        <TableCell align="center">{row.avg_buy_per}</TableCell>
        <TableCell align="center">
          {row.sentiment === "Bullish" ? (
            <div className="badge  btn-call p-2 rounded-pill">
              {/* <TrendingUpIcon color='action'></TrendingUpIcon> */}
              {row.sentiment}
            </div>
          ) : (
            <div className="badge  btn-put p-2 rounded-pill">
              {/* <TrendingDownIcon color='error'></TrendingDownIcon> */}
              {row.sentiment}
            </div>
          )}
        </TableCell>
      </StyledTableRow>

      {open && (
        <StyledTableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <Typography
                  variant="body-1"
                  gutterBottom
                  component="div"
                  style={{ transform: "translateX(5%)" }}
                >
                  <span className="text-black-50">Collapse</span>
                </Typography>
                <div
                  className="shadow border p-2 mb-5 rounded-xl"
                  style={{ transform: "translateX(4%)" }}
                >
                  <Table
                    className="table-striped"
                    size="small"
                    aria-label="purchases"
                  >
                    <TableHead>
                      <StyledTableRow>
                        <TableCell
                          className="font-weight-bold"
                          style={{
                            fontSize: 14,
                          }}
                        >
                          Date
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            fontSize: 14,
                          }}
                          className="font-weight-bold"
                        >
                          Call Premium
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            fontSize: 14,
                          }}
                          className="font-weight-bold"
                        >
                          Put Premium
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            fontSize: 14,
                          }}
                          className="font-weight-bold"
                        >
                          Common Strike
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            fontSize: 14,
                          }}
                          className="font-weight-bold"
                        >
                          Common Expire
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            fontSize: 14,
                          }}
                          className="font-weight-bold"
                        >
                          Buy Order
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            fontSize: 14,
                          }}
                          className="text-danger font-weight-bold"
                        >
                          Total Premium
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            fontSize: 14,
                          }}
                          className="font-weight-bold"
                        >
                          Sentiment
                        </TableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {row.history.map((historyRow) => (
                        <StyledTableRow key={historyRow.date}>
                          <TableCell component="th" scope="row">
                            {historyRow.date}
                          </TableCell>
                          <TableCell align="center">
                            <NumberFormat
                              value={historyRow.call}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"$ "}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <NumberFormat
                              value={historyRow.put}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"$ "}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <NumberFormat
                              value={historyRow.common_strike}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"$ "}
                            />
                          </TableCell>
                          <TableCell align="center">
                            {historyRow.common_exp}
                          </TableCell>
                          <TableCell align="center">
                            {historyRow.buy_order}
                          </TableCell>
                          <TableCell
                            align="center"
                            className="text-danger font-weight-bold"
                          >
                            <NumberFormat
                              value={historyRow.totoal_premium}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"$ "}
                            />
                          </TableCell>
                          <TableCell align="center">
                            {historyRow.sentiment === "Bullish" ? (
                              <div className="badge  btn-call p-2 rounded-pill">
                                {/* <TrendingUpIcon color='action'></TrendingUpIcon> */}
                                {historyRow.sentiment}
                              </div>
                            ) : historyRow.sentiment === "Bearish" ? (
                              <div className="badge btn-put p-2 rounded-pill">
                                {/* <TrendingDownIcon color='error'></TrendingDownIcon> */}
                                {historyRow.sentiment}
                              </div>
                            ) : (
                              historyRow.sentiment
                            )}
                          </TableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </Box>
            </Collapse>
          </TableCell>
        </StyledTableRow>
      )}
    </React.Fragment>
  );
}

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

Row.propTypes = {
  row: PropTypes.shape({
    ticker: PropTypes.string.isRequired,
    calories: PropTypes.number.isRequired,
    carbs: PropTypes.number.isRequired,
    fat: PropTypes.number.isRequired,
    history: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number.isRequired,
        customerId: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
      })
    ).isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    protein: PropTypes.number.isRequired,
  }).isRequired,
};

const History = () => {
  const [initialData, setInitialData] = useState(null);
  const [filteredData, setData] = useState(null);
  const [rangeValue, setRange] = useState(null);
  const [roleValue, setRoleValue] = useState(null);
  const [initialOpen, setInitialOpen] = useState(false);
  const classes = useStyles();
  const { activeUser } = useAuth();
  const [isCheckoutLoading, setCheckoutLoading] = useState(false);

  useEffect(() => {
    let historyData;
    db.collection("sum")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          if (doc.id === "history") {
            historyData = doc.data().topuoa;
            setData(historyData);
            setInitialData(historyData);
          }
        });
      });
    let role;

    getStripeRole().then((result) => {
      role = result;
      setRoleValue(role);
    });
    // let historyData;
    // rows.forEach((doc) => {
    //   if (doc.id === "history") {
    //     historyData = doc.data().topuoa;
    //   }
    // });
  }, []);

  useEffect(() => {
    if (rangeValue !== null) {
      let x = [];
      x = initialData.filter(
        (x) =>
          x.todays_vol >= rangeValue[0] * 1000000 &&
          x.todays_vol <= rangeValue[1] * 1000000
      );
      // console.log(x);
      setData(x);
    }
  }, [rangeValue]);

  const handleChange = (value) => {
    console.log(value);
    if (value === "" || value === null) {
      setData(initialData);
    } else {
      let x = [];
      x = initialData.filter((v) => v.ticker.toLowerCase().includes(value));
      setData(x);
    }
  };

  const handleSwitchInitialOpenChange = name => event => {
    // this.setState({ [name]: event.target.checked });
    setInitialOpen(!initialOpen);
  };

  return (
    <div className="pt-5 pb-5 bg-light-2" style={{ fontSize: `0.8rem` }}>
      <section className="pt-5 mb-5">
        <div className="container-fluid mb-5">
          <h1 className="text-center font-weight-bold mt-3 mb-5 py-3">
            Historical UOA Database
          </h1>

          <h4 className="text-center font-weight-light  my-3 py-1">
            Update Daily At 2:00 PM EST and 5:00 PM EST
          </h4>
          <div className="shadow border p-4 rounded-xl mx-xl-3 bg-white">
            <div className="mb-4">
             <FormControlLabel
                control={
                  <Switch
                    checked={initialOpen}
                    onChange={handleSwitchInitialOpenChange('checkedA')}
                    value="checkedA"
                  />
                }
                label="Expand All"
              />
              <h6 className="font-weight-bold mb-3">
                Filter By premium amount
              </h6>
              
              <div className="d-flex flex-column flex-md-row align-items-center justify-content-between">
                <RangeSlider setRange={setRange} />
                {/* TODO add real time uoa back */}
                {initialData === null || roleValue != "premium" ? (
                  <></>
                ) : (
                  <div className={` ${classes.buttonList}`}>
                  <Link
                    to="/realtime"
                    className={`btn btn-call rounded-pill px-3  +  ${classes.buttonListA}`}
                  >
                    <div className="d-flex align-items-center">
                      <span className="mr-1 small">
                        <QueryBuilderIcon style={{ fontSize: 25 }} />
                      </span>
                      <span>Real Time UOA</span>
                    </div>
                  </Link>
                  <Link
                    to="/alerts"
                    className="btn btn-call rounded-pill px-3"
                  >
                    <div className="d-flex align-items-center">
                      <span className="mr-1 small">
                        <AnnouncementIcon style={{ fontSize: 25 }} />
                      </span>
                      <span>Cash Secured Put Scan</span>
                    </div>
                </Link>
                  </div>
                )}
              </div>
              <div className="d-flex align-items-center border-bottom border-dark mb-3 col-md-5 col-lg-3 px-0 ml-auto">
                <div className="mr-2">
                  <SearchIcon style={{ fontSize: 20 }} />
                </div>
                <InputBase
                  placeholder="Search…"
                  inputProps={{ "aria-label": "search" }}
                  onChange={(e) => handleChange(e.target.value.toLowerCase())}
                />
              </div>
              <TableContainer
                component={Paper}
                style={{ border: 0, boxShadow: "unset" }}
              >
                <Table aria-label="collapsible table">
                  <TableHead className={classes.head}>
                    <StyledTableRow>
                      <TableCell className={classes.headFont}>Ticker</TableCell>
                      <TableCell className={classes.headFont} align="center">
                        Todays Vol
                      </TableCell>
                      <TableCell className={classes.headFont} align="center">
                        30 Days AVG Vol
                      </TableCell>
                      <TableCell className={classes.headFont} align="center">
                        Relative Vol
                      </TableCell>
                      <TableCell className={classes.headFont} align="center">
                        Past Call
                      </TableCell>
                      <TableCell className={classes.headFont} align="center">
                        Past Put
                      </TableCell>
                      <TableCell className={classes.headFont} align="center">
                        Avg Buy Order
                      </TableCell>
                      <TableCell className={classes.headFont} align="center">
                        Sentiment
                      </TableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {initialData === null || roleValue !== "premium" ? (
                      <>
                        <CircularProgress />
                        { roleValue !== "premium" ? 
                          "Please subscribe to premium membership " : 
                          "Loading"
                        }
                        <Button
                          className="btn btn-call px-3"
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            setCheckoutLoading(true);
                            if (initialData != null && roleValue != "premium") {
                              createCheckoutSession(activeUser.uid);
                            } else {
                              goToBillingPortal();
                            }
                          }}
                        >
                          Upgrade to Premium
                        </Button>
                      </>
                    ) : (
                      filteredData.map((row) => (
                        <Row key={row.ticker} row={row} initialOpen={initialOpen}/>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default History;
